// extracted by mini-css-extract-plugin
export default {"header":"LargeHeader_header__tu4qo"};